<div class="flex items-center justify-center h-full">
  <div class="flex md:w-2/4 mt-20 items-center justify-center text-center m-10">
    <activar-card>
      @if(policyResponse?.policies && policyResponse.policies.length > 0) {
        <div class="flex items-center justify-center">
          <activar-icon name="success" size="60px" class="mb-5" />
        </div>

        <h2 class="mb-3">Póliza emitida con éxito</h2>

        <div *showForChannels="['agents']" class="space-y-3">
          <p class="text-sm sm:text-base leading-relaxed">
            La póliza ha sido emitida correctamente. El cliente recibirá un correo con los detalles de su nueva póliza.
          </p>
        </div>

        <div *showForChannels="['direct']" class="mb-3 space-y-3">
          <p class="text-sm sm:text-base leading-relaxed">
            Tu póliza ha sido emitida correctamente.
          </p>

          @if (isNewClient()) {
            <p class="text-sm sm:text-base leading-relaxed">
              Te enviamos un mail con los detalles para acceder a la app y controlar tu póliza.
            </p>
          }
        </div>

        @if(isVehicle()){
        <p class="text-sm sm:text-base leading-relaxed mb-3">
          Recordá que la emisión de las pólizas se realizan con la primera
          activación.
        </p>
        }

        <div class="flex flex-col gap-3 mt-6" *showForChannels="['agents']">
          <activar-button
            color="primary"
            text="Volver a pólizas"
            expand="full"
            fill="out"
            (click)="goToNewPolicy()" />

          @for(policy of policyResponse.policies; track policy.id){
            <activar-button
              color="primary"
              text="Ver póliza {{showName(policy.type)}}"
              expand="full"
              (click)="viewDetail(policy.id)" />

            @if(!isVehicle()){
              <activar-button
                fill="out"
                text="Descargar certificado"
                expand="full"
                [loading]="isDownloading(policy.id)"
                loadingText="Descargando..."
                (click)="downloadCertificate(policy.id)" />
            }
          }
        </div>

        <div class="flex flex-col gap-3 mt-6" *showForChannels="['direct']">
          <activar-button
            color="primary"
            text="Ir al inicio"
            expand="full"
            fill="out"
            (click)="goHome()" />

          @for(policy of policyResponse.policies; track policy.id){
            @if(!isVehicle()){
              <activar-button
                color="secondary"
                text="Descargar certificado"
                expand="full"
                [loading]="isDownloading(policy.id)"
                loadingText="Descargando..."
                (click)="downloadCertificate(policy.id)" />
            }
          }
        </div>
      } @else {
        <!-- Error state when no policy data is available -->
        <div class="flex items-center justify-center">
          <activar-icon name="error" size="60px" class="mb-5" />
        </div>

        <h2 class="mb-3">Error al cargar los datos</h2>

        <p class="text-sm sm:text-base leading-relaxed mb-6">
          No se pudieron cargar los datos de la póliza. Por favor, intenta nuevamente.
        </p>

        <activar-button
          color="primary"
          text="Volver a pólizas"
          expand="full"
          (click)="goToNewPolicy()" />
      }
    </activar-card>
  </div>
</div>